import React from 'react';

const AddAdmin = () => {
    return (
        <div>
            <h2 className='text-5xl' > Add Admin</h2>
        </div>
    );
};

export default AddAdmin;